import { EModalAssetsManagerView, ModalAssetsManager } from 'src/components/ModalAssetsManager';
import {
  initialApplicationState,
  setModalCommunitySummaryView,
} from 'src/redux/application/application.slice';

import React from 'react';
import { TModalCommunitySummaryProps } from './ModalCommunitySummary.types';
import { selectModalCommunitySummaryView } from 'src/redux/application/application.selectors';
import { useAppDispatch } from 'src/redux/store';
import { useSelector } from 'react-redux';

export const ModalCommunitySummary: React.FC<TModalCommunitySummaryProps> = ({ ...rest }) => {
  const dispatch = useAppDispatch();
  const modalCommunitySummaryView = useSelector(selectModalCommunitySummaryView);
  return (
    <ModalAssetsManager
      summaryIcon="market"
      view={modalCommunitySummaryView}
      viewOnDestroy={initialApplicationState.modalCommunitySummaryView}
      disallowReturnToSummary={() =>
        dispatch(setModalCommunitySummaryView(EModalAssetsManagerView.SaveOrSettings))
      }
      onViewChange={(v) => {
        dispatch(setModalCommunitySummaryView(v));
      }}
      {...rest}
    />
  );
};
